import {
  Component,
  effect,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";

import { ToastrService } from "ngx-toastr";

import { CartsService } from "../../../../shared/services/carts.service";
import { GlobalService } from "../../../../shared/services/global.service";

import { CommonModule } from "@angular/common";
import { NgbModal, NgbNavModule, NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { LaddaModule } from "angular2-ladda";
import * as moment from "moment";
import { AvatarModule } from "ngx-avatars";
import { NgxTrimDirectiveModule } from "ngx-trim-directive";
import { SharedModule } from "primeng/api";
import { CalendarModule } from "primeng/calendar";
import { DialogModule } from "primeng/dialog";
import { DisplayDescriptionComponent } from "src/app/shared/components/display-description/display-description.component";
import {
  API_URLS,
  DATEFORMATE,
  FILE_PATH,
  MOMENT_FORMAT_START_DATE,
  MOMENT_FORMAT_START_YEAR,
  P_CALENDAR_DATE_FORMAT,
  PRODUCT_PATH,
} from "../../../../config/app.constants";
import { OutPostModalService } from "../../../../shared/header/outpost-list-modal/out-post-modal.service";
import { SafeHtmlPipe } from "../../../../shared/pipes/safe-html.pipe";
import { HttpinterceptorService } from "../../../../shared/services/httpinterceptor.service";
import { SpinnerComponent2 } from "../../../../shared/spinners/spinner2.component";
import { Utils } from "../../../../shared/utils";
import { StarRatingComponent } from "../../star-rating/star-rating.component";

declare var $: any;

@Component({
  selector: "app-cage-booking-modal",
  templateUrl: "./cage-booking-modal.component.html",
  styleUrls: ["./cage-booking-modal.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    CalendarModule,
    FormsModule,
    SharedModule,
    SpinnerComponent2,
    StarRatingComponent,
    ReactiveFormsModule,
    NgxTrimDirectiveModule,
    NgbTooltip,
    AvatarModule,
    LaddaModule,
    DialogModule,
    SafeHtmlPipe,
    NgbNavModule,
  ],
})
export class CageBookingModalComponent implements OnInit {
  @Input() fromParent;

  @Input() set bookingPetDetails(val) {
    if (val) {
      this.petDetail = val;
      this.ngOnInit();
      this.petTypeId = this.petDetail.pet_type_id;
      this.getCurrentPetType();
      this.getPets();
      this.getProductList();

      this.cartDetails = JSON.parse(this.cartsService.getCartItems());

      // Get Product from Cart APi

      this.cartDetails.items.forEach((cart) => {
        if (cart.pets && cart.pets.length) {
          this.selectedProduct = cart.pets[0].product_ids.split(",");
        }
      });
      if (localStorage.getItem("selectedOutpostId")) {
        this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
      }
    }
  }

  @Input() set planDetails(val) {
    if (val) {
      this.planDetail = val;
      this.selectedCageTypeId = this.planDetail.id;
    }
  }

  @Input() set showPlanModal(val) {
    if (val) {
      this.resetData();
      if (this.planDetail?.planEditMode) {
        this.editBookingInfo();
      }
      this.openModal();
    }
  }

  @Output() closePlanModal = new EventEmitter<boolean>();

  @ViewChild("checkout") checkout: any;
  selectedAddonDetail: any;
  selectedPetId: any;
  selected_option: any = {};
  // @ViewChild("optionModal") optionModal: ElementRef;
  selectedPetIndex: any;
  selectedOptionValue: any;
  previousSelectedOptionValue: any;
  previousSelectedDates: any;
  selectedAddonIndex: any;

  outwardMinute: any;
  inwardMinute: any;

  petDetail: any;
  planDetail: any;
  currentStep: any;

  boardingDateSubmitted: boolean = false;

  petTypeId: any;
  cageTypeGrid: any;
  checkInDate: any;
  checkoutDate: any;
  updatedAmount: any;
  inwardDate: Date;
  outwardDate: Date;

  inwardTime: any;
  outwardTime: any;

  inwardHour: any;
  outwardHour: any;

  totalDays: any;
  minInWardDate: Date;
  maxDate: Date;

  selectedDateArray = [];
  checkingAvailability: boolean = false;
  currentPetType: any;
  selectedCageTypeId: string = "";
  userPets = [];
  selectedUserPet = [];
  pets_array = [];
  selectedPet: any;
  pet_type: any[] = [];
  petSubTypeList = [];
  displayExtraPrice = [];
  myAddons = [];
  bookingDetails: any = [];
  defaultSubPetId: string = "";
  errorMessageInWardTime: string;
  errorMessageOutWardTime: string;
  is_advance_booking_amount = true;
  minimumPaymentFlag: boolean = false;
  maximumPaymentFlag: boolean = false;
  cartProcess: boolean = false;
  paymentSummary: boolean = false;
  cageDetailLoad: boolean = false;

  petAddLimit: number = 0;
  addedPetsCount: number = 0;

  pCalendarDateFormat: string = P_CALENDAR_DATE_FORMAT;
  filePath = FILE_PATH;
  format = DATEFORMATE;

  petDetails: FormGroup;
  pets = new FormControl("", {});
  selectedOutpostId;
  mandatoryProductList = [];
  isMandatoryProducts: boolean = false;
  selectedProduct = [];
  iscontinueDisabled: boolean = false;
  petWiseProduct = [];
  productImagePath = PRODUCT_PATH;

  stateHidden;
  currentOutpostId;
  isShowStep = false;
  cartDetails;
  formatDates: any = [];

  clinicTiming: any;
  days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  active: string = "tab8";
  isRightMarkForFirst: boolean = false;
  isRightMarkForSecond: boolean = false;
  isRightMarkForThird: boolean = false;
  isRightMarkForForth: boolean = false;
  isRightMarkForFifth: boolean = false;
  isRightMarkForSixth: boolean = false;
  activeTabs: string[] = [
    "plan",
    "time",
    "pet_details",
    "addons",
    "mandatory_products",
    "payment",
  ];
  constructor(
    private http: HttpinterceptorService,
    private toasterService: ToastrService,
    private cartsService: CartsService,
    private globalService: GlobalService,
    private formBuilder: FormBuilder,
    private outpostModalService: OutPostModalService,
    private modalService: NgbModal,
    private el: ElementRef,
    private renderer: Renderer2
  ) {
    const minTime = new Date();
    minTime.setHours(6);
    minTime.setMinutes(0);
    const MaxTime = new Date();
    MaxTime.setHours(20);
    MaxTime.setMinutes(0);
    this.inwardTime = minTime;
    this.outwardTime = MaxTime;

    // this.currentOutpostId = this.outpostModalService.currentPlan.subscribe(
    //   (el: any) => {
    //     if (localStorage.getItem("selectedOutpostId")) {
    //       this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
    //     }
    //   }
    // );

    effect(() => {
      const el = this.outpostModalService.activatedPlan();
      if (localStorage.getItem("selectedOutpostId")) {
        this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
      }
    });

    let today = new Date();
    today.setDate(today.getDate() + 25);
    this.maxDate = today;
  }

  ngOnInit(): void {
    this.minInWardDate = new Date();
    this.minInWardDate.setDate(this.minInWardDate.getDate() + 1); // Tomorrow Date
    this.minInWardDate.setHours(0, 0, 0, 0); // Set time to start of the day

    this.initializePetValidation();
    this.getBoardingAddons();
  }
  // ngOnDestroy(): void {
  //   //Called once, before the instance is destroyed.
  //   //Add 'implements OnDestroy' to the class.
  //   this.currentOutpostId.unsubscribe();
  // }
  // at the time edit modal fill data in pages
  editBookingInfo() {
    // set time in time selection
    const inTimeArray = new Date(this.planDetail.inward_time);
    const outTimeArray = new Date(this.planDetail.outward_time);
    const minTime = new Date();
    minTime.setHours(inTimeArray.getHours());
    minTime.setMinutes(inTimeArray.getMinutes());
    const maxTime = new Date();
    maxTime.setHours(outTimeArray.getHours());
    maxTime.setMinutes(outTimeArray.getMinutes());

    // set date into date selection
    this.inwardTime = minTime;
    this.outwardTime = maxTime;
    this.inwardDate = new Date(this.planDetail.booking_from);
    this.selectInwardDate();
    this.outwardDate = new Date(this.planDetail.booking_to);
    this.selectOutwardDate();

    // calculate total booking days
    const inward_date = Utils.getDateFormat(this.inwardDate);
    const outward_date = Utils.getDateFormat(this.outwardDate);
    const checkinDate =
      inward_date[0] + "/" + inward_date[1] + "/" + inward_date[2];
    const checkoutdate =
      outward_date[0] + "/" + outward_date[1] + "/" + outward_date[2];
    const checkinDiff = moment(checkinDate, MOMENT_FORMAT_START_DATE);
    const checkoutDiff = moment(checkoutdate, MOMENT_FORMAT_START_DATE);
    this.totalDays = checkoutDiff.diff(checkinDiff, "days");
    this.checkInDate =
      inward_date[2] + "/" + inward_date[1] + "/" + inward_date[0];
    this.checkoutDate =
      outward_date[2] + "/" + outward_date[1] + "/" + outward_date[0];
    this.is_advance_booking_amount = this.planDetail.is_advance_booking_amount;
    this.getDatesInRange();
  }

  // patch value in pat detail form at the time of edit modal
  saveBookingPatchValue() {
    this.addedPetsCount = this.pets_array.length;
    const control = <FormArray>this.petDetails.controls["pets"];
    const selectedPetArray = [];
    const bindPetArray = [];
    for (const key in this.pets_array) {
      if (this.pets_array.hasOwnProperty(key)) {
        if (!this.pets_array[key]["sub_pet_type_id"]) {
          this.pets_array[key]["sub_pet_type_id"] = this.defaultSubPetId;
        }
        if (
          typeof this.pets_array[key].pet_detail === "string" &&
          this.pets_array[key].pet_detail != null
        ) {
          this.pets_array[key].pet_detail = JSON.parse(
            this.pets_array[key].pet_detail
          );
        }
        const selectedPets = $.grep(this.pet_type, (val, inx) => {
          return val.id == this.pets_array[key].id;
        });
        if (selectedPets.length > 0) {
          selectedPetArray.push({
            id: this.pets_array[key].id,
            item_text: this.pets_array[key].name,
          });
          bindPetArray.push(this.pets_array[key].id);
        }
        control.push(this.initPets());
      }
    }
    this.selectedUserPet = bindPetArray;
    this.petDetails.patchValue({ pets: this.pets_array });
  }

  // initialize pet form
  initializePetValidation() {
    this.petDetails = this.formBuilder.group({
      pets: this.formBuilder.array([]),
    });
  }

  // get the days selected to display
  getSelectedDays(date) {
    if (!this.outwardDate) {
      if (this.inwardDate) {
        const format = date.day + "/" + (date.month + 1) + "/" + date.year;
        return this.selectedDateArray.includes(format);
      }
    } else {
      const format = date.day + "/" + (date.month + 1) + "/" + date.year;
      return this.selectedDateArray.includes(format);
    }
  }

  // select time of inward
  selectInwardDate() {
    this.getClinicTiming();

    if (this.inwardDate) {
      this.selectedDateArray = [];
      const date = Utils.getDateFormat(this.inwardDate);
      this.selectedDateArray.push(date[0] + "/" + date[1] + "/" + date[2]);
      const expectedOutwardDate = this.addDays(this.inwardDate, 1);
      this.outwardDate = expectedOutwardDate;
      const expectedOutward = Utils.getDateFormat(expectedOutwardDate);
      this.selectedDateArray.push(
        expectedOutward[0] + "/" + expectedOutward[1] + "/" + expectedOutward[2]
      );
      if (this.checkout) {
        this.checkout.showOverlay(
          this.checkout.inputfieldViewChild.nativeElement
        );
      }
    }
  }

  // select time of outward
  selectOutwardDate() {
    this.getClinicTiming();

    const inwardDate = Utils.getDateFormat(this.inwardDate);
    const outwardDate = Utils.getDateFormat(this.outwardDate);
    const checkInDate =
      inwardDate[0] + "/" + inwardDate[1] + "/" + inwardDate[2];
    const checkoutDate =
      outwardDate[0] + "/" + outwardDate[1] + "/" + outwardDate[2];
    if (checkInDate == checkoutDate) {
      this.outwardDate = null;
      this.selectInwardDate();
      return false;
    } else {
      const checkInDiff = moment(checkInDate, MOMENT_FORMAT_START_DATE);
      const checkoutDiff = moment(checkoutDate, MOMENT_FORMAT_START_DATE);
      this.totalDays = checkoutDiff.diff(checkInDiff, "days");
      this.getDatesInRange();

      // Reset addon control

      if (this.myAddons && this.myAddons.length) {
        for (const addon of this.myAddons) {
          addon.addonCheckoutPrice = 0;
        }
      }

      const control = <FormArray>this.petDetails.controls["pets"];
      for (const index in control.controls) {
        let addonArray = <FormControl>(
          control.controls[index]["controls"]["addons"]
        );
        addonArray.setValue([]);
      }

      // End

      this.selectedDateArray = [];
      const date = Utils.getDateFormat(this.inwardDate);
      this.selectedDateArray.push(date[0] + "/" + date[1] + "/" + date[2]);
      for (let i = 1; i <= this.totalDays; i++) {
        const expectedOutwardDate = this.addDays(this.inwardDate, i);
        const expectedOutward = Utils.getDateFormat(expectedOutwardDate);
        this.selectedDateArray.push(
          expectedOutward[0] +
            "/" +
            expectedOutward[1] +
            "/" +
            expectedOutward[2]
        );
      }
    }
  }

  addDays(date, count) {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + count);
    return newDate;
  }

  // check if the cage is available on selected dates
  checkCageAvailability() {
    this.boardingDateSubmitted = true;
    if (!this.inwardDate || !this.outwardDate) {
      return false;
    } else {
      const inwardDate = Utils.getDateFormat(this.inwardDate);
      const outwardDate = Utils.getDateFormat(this.outwardDate);
      const inward_date =
        inwardDate[1] + "/" + inwardDate[0] + "/" + inwardDate[2];
      const outward_date =
        outwardDate[1] + "/" + outwardDate[0] + "/" + outwardDate[2];
      this.checkingAvailability = true;
      this.http
        .post(
          API_URLS.CHECK_CAGE_AVAILABILITY,
          {
            cage_type_id: this.selectedCageTypeId,
            no_of_pet: 1,
            inward_date: inward_date,
            outward_date: outward_date,
            out_post_id: this.selectedOutpostId,
          },
          false
        )
        .subscribe(
          (response) => {
            this.checkingAvailability = false;
            this.boardingDateSubmitted = false;
            if (response.data) {
              if (response.data.status === "available") {
                this.getCageTypeDetails();
                this.getPetExtraPrice();
                this.goToNext("plan");
              } else {
                this.toastMessage(
                  "error",
                  "Cage is not available for selected dates"
                );
                return false;
              }
            }
          },
          (error) => {
            this.checkingAvailability = false;
            return false;
          }
        );
    }
  }

  // get user pets
  getPets() {
    this.http
      .post(API_URLS.GET_USER_PETS, { pet_type_id: this.petTypeId }, false)
      .subscribe((res) => {
        if (res.type === "success") {
          this.pet_type = [];
          if (res.data) {
            res.data = res.data.filter((pet) => pet?.is_active);
            for (const index in res.data) {
              if (res.data.hasOwnProperty(index)) {
                if (
                  typeof res.data[index].pet_detail === "string" &&
                  res.data[index].pet_detail !== null &&
                  res.data[index].pet_detail
                ) {
                  res.data[index]["pet_detail"] = JSON.parse(
                    res.data[index].pet_detail
                  );
                } else {
                  res.data[index]["pet_detail"] = {};
                }
                this.pet_type.push({
                  id: res.data[index].id,
                  item_text: res.data[index].name,
                });
              }
            }
            this.userPets = res.data;
          }
          if (this.petDetail) {
            this.selectPetFromPetDetail();
          }
        }
      });
  }

  // get pet type
  getCurrentPetType() {
    this.globalService.getPetTypes().subscribe((data) => {
      const petTypeList = data;
      this.currentPetType =
        petTypeList[
          petTypeList.indexOf(
            petTypeList.find(({ id }) => {
              return id == this.petTypeId;
            })
          )
        ];
    });
  }

  // on pet select from list
  selectPetFromPetDetail() {
    this.selectedPet = this.userPets.find((pet) => pet.id == this.petDetail.id);
    if (this.planDetail.planEditMode) {
      this.pets_array = [this.petDetail];
      this.saveBookingPatchValue();
    } else {
      this.onSelectPet(this.selectedPet);
    }
  }

  // set pet detail into form
  onSelectPet(event) {
    if (event.id) {
      const petDetails_res = this.userPets.filter(function (data) {
        return data.id == event.id;
      });
      const control = <FormArray>this.petDetails.controls["pets"];
      for (const iterator of petDetails_res) {
        control.push(this.initPets());
      }
      petDetails_res[0]["pet_type_id"] = event.pet_type_id;
      if (!petDetails_res[0]["sub_pet_type_id"]) {
        petDetails_res[0]["sub_pet_type_id"] = this.defaultSubPetId;
      }
      this.pets_array = [];
      for (let index in this.petDetails.value.pets) {
        if (parseInt(index) !== this.petDetails.value.pets.length - 1) {
          this.pets_array.push(this.petDetails.value.pets[index]);
        }
      }
      this.pets_array.push(petDetails_res[0]);
      this.petDetails.patchValue({ pets: this.pets_array });
      this.addedPetsCount += 1;
    }
  }

  // remove pet from form
  onRemovePet(event) {
    const control = <FormArray>this.petDetails.controls["pets"];
    for (let index = 0; index < control.controls.length; index++) {
      if (event.value.id == control.controls[index].value.id) {
        control.removeAt(index);
        this.pets_array.splice(index, 1);
      }
    }
    this.addedPetsCount -= 1;
  }

  // return pet form with form builder
  initPets() {
    return this.formBuilder.group({
      id: [""],
      name: ["", [Validators.required]],
      pet_type_id: [""],
      sub_pet_type_id: [""],
      description: [""],
      age: ["", [Validators.pattern("^[0-9]*$")]],
      color: [""],
      sex: [""],
      sunPetType: [""],
      weight: ["", [Validators.pattern("^[0-9]*$")]],
      breed: [""],
      microchip: [""],
      pet_detail: this.formBuilder.group({
        feeding_instruction: ["", []],
        pet_likes: ["", []],
        pet_dis_likes: ["", []],
        pet_schedule_complete_day: ["", []],
        care_instruction: ["", []],
        allergies: ["", []],
      }),
      addons: [[], []],
    });
  }

  // get list of boarding addons
  getBoardingAddons() {
    this.http.post(API_URLS.GET_BOARDING_ADDONS, {}, false).subscribe((res) => {
      this.myAddons = [];
      if (res.data) {
        this.myAddons = res.data;
      }

      if (
        this.petDetail &&
        this.petDetail.addons &&
        this.petDetail.addons.length &&
        this.myAddons &&
        this.myAddons.length
      ) {
        for (const addon of this.myAddons) {
          for (const petDetail of this.petDetail.addons) {
            if (addon.id == petDetail.id) {
              addon.addonCheckoutPrice =
                addon.price * petDetail.selected_dates.length;
            }
          }
        }
      }
    });
  }

  // on select or unselect addon
  onSelectAddon(optionModal, event, id, value, petId, addonInd, pet_i) {
    this.selectedAddonDetail = value;
    this.selectedPetIndex = pet_i;
    this.selectedAddonIndex = addonInd;

    let addonCheckboxElement = document.getElementById(
      `addonCheckbox${pet_i}_${addonInd}`
    ) as HTMLInputElement;

    if (!event) {
      if (addonCheckboxElement) {
        addonCheckboxElement.checked = !addonCheckboxElement.checked; // Set to true or false based on your requirement
      }
    }

    const checkinDiff = moment(this.checkInDate, MOMENT_FORMAT_START_YEAR);
    const checkoutDiff = moment(this.checkoutDate, MOMENT_FORMAT_START_YEAR);

    this.totalDays = checkoutDiff.diff(checkinDiff, "days");

    const control = <FormGroup>(
      this.petDetails.controls["pets"]["controls"][this.selectedPetIndex]
    );

    let addons = JSON.parse(JSON.stringify(control.value.addons));

    let addonControl = <FormControl>control.get("addons");

    if (
      addonCheckboxElement.checked &&
      ((value.options && value.options.length) ||
        this.selectedAddonDetail.type == "custom")
    ) {
      addonCheckboxElement.checked = false;
      this.selectOptionModal(optionModal, value, petId, pet_i, addonInd);
    } else if (!addonCheckboxElement.checked) {
      const index = addons.findIndex((addonId) => addonId.id === id);
      if (index !== -1) {
        addons.splice(index, 1);
      }

      for (let i = 0; i < this.myAddons.length; i++) {
        if (this.myAddons[i].id == this.selectedAddonDetail.id) {
          this.myAddons[i].addonCheckoutPrice = 0;
        }
      }

      addonControl.setValue(addons);
    }

    if (
      this.selectedAddonDetail.type !== "custom" &&
      addonCheckboxElement.checked
    ) {
      let addonObj = {
        id: this.selectedAddonDetail.id,
        selected_dates: [],
        selected_option: "",
        type: this.selectedAddonDetail.type,
      };
      addons.push(addonObj);
      addonControl.setValue(addons);
      this.onSubmit();
    }
  }

  // get booking price from API
  getBookingPrice() {
    const pets = [];
    for (let index = 0; index < this.petDetails.value.pets.length; index++) {
      const pet = {
        id: this.petDetails.value.pets[index].id,
        name: this.petDetails.value.pets[index].name,
        pet_type_id: this.petTypeId,
        sub_pet_type_id: !this.petDetails.value.pets[index].sub_pet_type_id
          ? this.defaultSubPetId
          : this.petDetails.value.pets[index].sub_pet_type_id,
        addons:
          this.petDetails.value.pets[index].addons !== null
            ? this.petDetails.value.pets[index].addons
            : [],
      };
      pets.push(pet);

      for (const pet in pets) {
        if (Object.prototype.hasOwnProperty.call(pets, pet)) {
          pets[pet]["product_ids"] = this.isMandatoryProducts
            ? this.selectedProduct.toString()
            : "";
        }
      }
    }
    const checkin_date = Utils.getDateFormat(this.inwardDate);
    this.checkInDate =
      checkin_date[2] + "/" + checkin_date[1] + "/" + checkin_date[0];
    const checkout_date = Utils.getDateFormat(this.outwardDate);
    this.checkoutDate =
      checkout_date[2] + "/" + checkout_date[1] + "/" + checkout_date[0];
    this.paymentSummary = true;
    this.http
      .post(
        API_URLS.BOOKING_PRICE,
        {
          cage_type_id: this.selectedCageTypeId,
          booking_from: this.checkInDate,
          booking_to: this.checkoutDate,
          pet_type_id: this.petTypeId,
          out_post_id: this.selectedOutpostId,
          pets: pets,
        },
        false
      )
      .subscribe(
        (response) => {
          this.paymentSummary = false;
          if (response.type === "success" && response.code === 200) {
            if (response.data) {
              this.bookingDetails = response.data;
              this.updatedAmount =
                this.planDetail.planEditMode &&
                this.planDetail.advance_payment <= response.data.total
                  ? this.planDetail.advance_payment
                  : response.data.total;
            }
          } else {
            this.toasterService.error(response.message);
            this.goToPrev();
          }
        },
        (error) => {
          this.paymentSummary = false;
        }
      );
  }

  // cage booking add to cart
  bookingApply() {
    let cartDetailsToSend = {};
    if (this.petDetails.value.pets.length > 0) {
      for (const index in this.petDetails.value.pets) {
        if (this.petDetails.value.pets.hasOwnProperty(index)) {
          if (
            this.petDetails.value.pets[index].pet_detail &&
            typeof this.petDetails.value.pets[index].pet_detail === "object"
          ) {
            this.petDetails.value.pets[index]["pet_detail"] = JSON.stringify(
              this.petDetails.value.pets[index].pet_detail
            );
          }
          this.petDetails.value.pets[index]["sub_pet_type_id"] = !this
            .petDetails.value.pets[index].sub_pet_type_id
            ? this.defaultSubPetId
            : this.petDetails.value.pets[index].sub_pet_type_id;
        }
      }
    }

    for (const pet in this.petDetails.value.pets) {
      if (
        Object.prototype.hasOwnProperty.call(this.petDetails.value.pets, pet)
      ) {
        this.petDetails.value.pets[pet]["product_ids"] =
          this.stateHidden === "normal" ? this.selectedProduct.toString() : "";
      }
    }
    const event = new Date(this.inwardTime);
    const inwardTime = event.toLocaleTimeString("it-IT");
    const event2 = new Date(this.outwardTime);
    const outwardTime = event2.toLocaleTimeString("it-IT");
    cartDetailsToSend["out_post_id"] = this.selectedOutpostId;
    cartDetailsToSend["item_type"] = "boarding";
    cartDetailsToSend["booking_from"] = this.checkInDate;
    cartDetailsToSend["booking_to"] = this.checkoutDate;
    cartDetailsToSend["cage_booking_id"] = "";
    cartDetailsToSend["cage_type_id"] = this.cageTypeGrid.id;
    cartDetailsToSend["inward_time"] = inwardTime;
    cartDetailsToSend["outward_time"] = outwardTime;
    cartDetailsToSend["is_advance_booking_amount"] =
      this.is_advance_booking_amount;
    cartDetailsToSend["paid_amount"] = this.is_advance_booking_amount
      ? this.updatedAmount
      : 0;
    cartDetailsToSend["pet_type_id"] = this.petTypeId;
    cartDetailsToSend["pets"] = this.petDetails.value.pets;
    cartDetailsToSend["cart_id"] = this.planDetail.planEditMode
      ? this.planDetail.cart_id
      : "";
    this.cartProcess = true;
    this.http.post(API_URLS.UPDATE_CART, cartDetailsToSend, true).subscribe(
      (res) => {
        this.cartProcess = false;
        if (res.type === "success" && res.code === 200) {
          if (res.data) {
            this.resetData();
            this.cartsService.getCartWithApi();
            this.closeModal(true);
          }
        }
      },
      (error) => {
        this.cartProcess = false;
        return false;
      }
    );
  }

  // get detail of selected cage
  getCageTypeDetails() {
    this.cageDetailLoad = true;
    this.http
      .post(
        API_URLS.GET_CAGE_TYPE_DETAILS,
        {
          cage_type_id: this.selectedCageTypeId,
          out_post_id: this.selectedOutpostId,
        },
        false
      )
      .subscribe((res) => {
        if (res.data) {
          this.petAddLimit = res.data.allow_pet_number;
          if (res.data.size) {
            const data = res.data.size.split(",");
            res.data["width"] = data[0];
            res.data["height"] = data[1];
            res.data["length"] = data[2];
            res.data["unit"] = data[3];
          }
          this.cageTypeGrid = res.data;
          this.cageDetailLoad = false;
        }
      });
  }

  // get extra price list of the pet for cage booking
  getPetExtraPrice() {
    this.http
      .post(
        API_URLS.PET_EXTRA_PRICE,
        { cage_type_id: this.selectedCageTypeId, pet_type_id: this.petTypeId },
        false
      )
      .subscribe((response) => {
        if (response.code == "200") {
          this.petSubTypeList = [];
          this.displayExtraPrice = [];
          if (response.data.length > 0) {
            if (response.data[0].sub_pet_type_id !== null) {
              this.petSubTypeList = response.data;
            }
            this.displayExtraPrice = response.data;
          }
          const defaultPet = $.grep(this.petSubTypeList, function (val, inx) {
            return val.is_default == 1;
          });
          if (defaultPet.length && defaultPet[0].sub_pet_type_id) {
            this.defaultSubPetId = defaultPet[0].sub_pet_type_id;
          } else {
            this.defaultSubPetId = "";
          }
        }
      });
  }

  // calculate minimum and maximum payable amount with validation
  calculateMinimumAmount(minimumAmount) {
    if (parseFloat(minimumAmount) == 0) {
      this.minimumPaymentFlag = true;
      this.maximumPaymentFlag = false;
      return false;
    } else if (
      parseFloat(minimumAmount) > 0 &&
      minimumAmount <= this.bookingDetails["total"]
    ) {
      this.maximumPaymentFlag = false;
      this.minimumPaymentFlag = false;
      return false;
    } else if (parseFloat(minimumAmount) < 0) {
      this.minimumPaymentFlag = true;
      this.maximumPaymentFlag = false;
    } else {
      this.maximumPaymentFlag = true;
      this.minimumPaymentFlag = false;
      return false;
    }
  }

  // select time for inward and outward of pet
  selectTime(time) {
    const d = new Date(time == "inward" ? this.inwardTime : this.outwardTime);
    const hour = d.getHours();
    const minute = d.getMinutes();

    if (time == "inward") {
      if (hour < this.inwardHour) {
        const defaultTime = new Date();
        defaultTime.setHours(this.inwardHour);
        defaultTime.setMinutes(0);
        this.inwardTime = defaultTime;
        this.errorMessageInWardTime = `Please select drop-off time time after ${this.inwardHour}:00 AM!`;
      } else {
        this.errorMessageInWardTime = "";
        return true;
      }
    } else {
      if (
        hour > this.outwardHour ||
        `${hour}:${minute}` > `${this.outwardHour}:${this.outwardMinute}`
      ) {
        const defaultTime = new Date();
        defaultTime.setHours(this.outwardHour);
        defaultTime.setMinutes(0);
        this.outwardTime = defaultTime;
        this.errorMessageOutWardTime = `Please select pick-up time time before ${
          this.outwardHour - 12
        }:00 PM!`;
      } else {
        this.errorMessageOutWardTime = "";
        return true;
      }
    }
  }

  toastMessage(type, message) {
    this.toasterService[type](message);
  }

  // reset modal data
  resetData() {
    this.boardingDateSubmitted = false;
    this.inwardDate = undefined;
    this.outwardDate = undefined;
    this.removePetSelection();
    this.petDetails.reset();
    this.resetNavTab();
  }

  // remove all pet selection from form array
  removePetSelection() {
    const control = <FormArray>this.petDetails.controls["pets"];
    while (control.length !== 0) {
      control.removeAt(0);
    }
  }

  openModal() {
    $("#boardingPlanModal").modal("show");
  }

  closeModal(flag?) {
    $("#boardingPlanModal").modal("hide");
    Utils.enableBodyScroll();
    this.closePlanModal.emit(flag ? true : false);
  }

  // Get Mandatory product list
  getProductList() {
    this.isShowStep = false;
    this.http
      .post(
        API_URLS.MANDATORY_PRODUCTS_LIST,
        {
          pet_ids: [this.petDetail.id],
          pet_type_id: this.petTypeId,
        },
        false
      )
      .subscribe(
        (response) => {
          if (
            response.code === 200 &&
            response.type === "success" &&
            response.data
          ) {
            for (const data in response.data) {
              if (Object.prototype.hasOwnProperty.call(response.data, data)) {
                response.data[data]["mandatory_products"] = response.data[
                  data
                ].mandatory_products.filter(
                  (product) => product.status_to_given
                );
              }
            }

            for (const data in response.data) {
              this.selectedProduct = [];
              if (response.data.hasOwnProperty(data)) {
                for (const product in response.data[data].mandatory_products) {
                  if (
                    Object.prototype.hasOwnProperty.call(
                      response.data[data].mandatory_products,
                      product
                    )
                  ) {
                    response.data[data].mandatory_products[product][
                      "description"
                    ] = Utils.htmlToPlaintext(
                      response.data[data].mandatory_products[product]
                        .description
                    );
                  }
                  this.selectedProduct.push(
                    response.data[data].mandatory_products[product]["id"]
                  );
                }
              }
            }

            this.cartDetails = JSON.parse(this.cartsService.getCartItems());
            if (this.cartDetails.items && this.cartDetails.items.length) {
              this.cartDetails.items.forEach((cart) => {
                if (
                  cart.item_type == "boarding" &&
                  cart.pets &&
                  cart.pets.length &&
                  cart.pets[0].id == this.petDetail.id
                ) {
                  this.selectedProduct = cart.pets[0].product_ids.split(",");
                }
              });
            }

            this.mandatoryProductList = response.data.filter(
              (data) => data.mandatory_products.length
            );

            this.isMandatoryProducts = this.mandatoryProductList.some(
              (data) => {
                if (data.mandatory_products.length > 0) {
                  return true;
                } else {
                  return false;
                }
              }
            );
            /*   if (this.isMandatoryProducts) {
              this.stateHidden = this.stepStates.normal;
            } else {
              this.stateHidden = this.stepStates.hidden;
            } */
            this.isShowStep = true;
          } else {
            return false;
          }
        },
        (error) => {
          return false;
        }
      );
  }
  selectvaccins(product) {
    if (this.selectedProduct.indexOf(product.id) == -1) {
      this.selectedProduct.push(product.id);
    } else {
      for (const key in this.selectedProduct) {
        if (this.selectedProduct.hasOwnProperty(key)) {
          if (this.selectedProduct[key] == product.id) {
            this.selectedProduct.splice(parseInt(key), 1);
          }
        }
      }
    }
  }

  showDescription(planName, description) {
    const apiParams = { title: planName, description: description };
    const modalRef = this.modalService.open(DisplayDescriptionComponent, {
      size: "xl",
      centered: true,
      backdrop: "static",
      keyboard: false,
    });

    modalRef.componentInstance.fromParent = { data: apiParams };
  }

  // close Addon option popup
  closeOptionModal() {
    let control = <FormControl>(
      this.petDetails.controls["pets"]["controls"][this.selectedPetIndex][
        "controls"
      ]["addons"]
    );

    const petControl = <FormArray>(
      this.petDetails.controls["pets"]["controls"][this.selectedPetIndex]
    );
    let addonControl = <FormControl>petControl.get("addons");
    let addonArray = JSON.parse(JSON.stringify(petControl.value.addons));

    const isAddonIncluded = control.value.some(
      (item) => item.id === this.selectedAddonDetail.id
    );

    if (!isAddonIncluded && this.selectedAddonDetail.options !== null) {
      this.selectedAddonDetail.options.map((option) => {
        option.isChecked = false;
      });
      this.selectedAddonDetail.options[0].isChecked = true;
    }

    if (isAddonIncluded && this.selectedAddonDetail.options !== null) {
      this.selectedAddonDetail.options.map((option) => {
        option.isChecked = false;
      });

      if (this.previousSelectedOptionValue == undefined) {
        this.selectedAddonDetail.options[0].isChecked = true;
      } else {
        this.selectedAddonDetail.options.map((option) => {
          if (option.value === this.previousSelectedOptionValue.value) {
            option.isChecked = true;
          }
        });

        for (let i = 0; i < addonArray.length; i++) {
          if (addonArray[i].id == this.selectedAddonDetail.id) {
            addonArray[i]["selected_option"] =
              this.previousSelectedOptionValue.value;
            addonArray[i]["selected_dates"] = this.previousSelectedDates;
          }
        }
      }
    } else {
      for (let i = 0; i < addonArray.length; i++) {
        if (addonArray[i].id == this.selectedAddonDetail.id) {
          addonArray[i]["selected_dates"] = this.previousSelectedDates;
        }
      }
    }
    addonControl.setValue(addonArray);

    this.modalService.dismissAll();
  }

  // Open popup when click on edit icon
  selectOptionModal(optionModal, addon, petID, i, addonIndex, from?: any) {
    this.getDatesInRange();

    this.totalDays = this.formatDates.length;

    this.modalService.open(optionModal, {
      size: "lg",
      centered: true,
      backdrop: "static",
      keyboard: false,
      windowClass: "backdrop-css",
    });
    this.selectedAddonDetail = addon;
    this.selectedPetId = petID;
    this.selectedPetIndex = i;
    this.selectedAddonIndex = addonIndex;

    if (
      this.selectedAddonDetail.options &&
      typeof this.selectedAddonDetail.options == "string"
    ) {
      this.selectedAddonDetail.options = JSON.parse(
        this.selectedAddonDetail.options
      );

      this.selectedAddonDetail.options = this.selectedAddonDetail.options.map(
        (value) => {
          return {
            value: value,
            isChecked: false,
          };
        }
      );
    }

    let control = <FormControl>(
      this.petDetails.controls["pets"]["controls"][this.selectedPetIndex][
        "controls"
      ]["addons"]
    );

    if (
      this.selectedAddonDetail.options &&
      this.selectedAddonDetail.options.length
    ) {
      this.previousSelectedOptionValue = this.selectedAddonDetail.options.find(
        (option) => option.isChecked
      );
    }

    let hasCheckedTrue;
    if (this.selectedAddonDetail.options !== null) {
      hasCheckedTrue = this.selectedAddonDetail.options.some(
        (option) => option.isChecked
      );
    }
    if (this.selectedAddonDetail.options !== null && !hasCheckedTrue) {
      this.selectedAddonDetail.options[0].isChecked = true;
    }

    const isAddonIncluded = control.value.some(
      (item) => item.id === this.selectedAddonDetail.id
    );

    if (!isAddonIncluded) {
      this.formatDates.map((date) => {
        date.isChecked = true;
      });
    }

    if (control.value) {
      for (const key in control.value) {
        if (Object.prototype.hasOwnProperty.call(control.value, key)) {
          for (const option in this.selectedAddonDetail.options) {
            if (
              Object.prototype.hasOwnProperty.call(
                this.selectedAddonDetail.options,
                option
              )
            ) {
              // this.selectedAddonDetail.options[option].isChecked = false;
              if (
                control.value[key].id == addon.id &&
                control.value[key]["selected_option"] == ""
              ) {
                this.selectedAddonDetail.options.map((option) => {
                  option.isChecked = false;
                });
                control.value[key]["selected_option"] =
                  this.selectedAddonDetail.options[0].value;
                this.selectedAddonDetail.options[0].isChecked = true;
              } else if (
                control.value[key].id == addon.id &&
                control.value[key]["selected_option"]
              ) {
                this.selectedAddonDetail.options.map((option) => {
                  option.isChecked = false;
                  if (option.value == control.value[key]["selected_option"]) {
                    option.isChecked = true;
                  }
                });
              }
            }
          }

          // For Date selection
          if (this.formatDates && this.formatDates.length) {
            if (
              control.value[key].id == addon.id &&
              !control.value[key]["selected_dates"].length
            ) {
              if (addon.type !== "single") {
                this.formatDates.map((date) => {
                  date.isChecked = true;
                  control.value[key]["selected_dates"].push(date.date);
                  control.value[key]["type"] = addon.type;
                });
              } else {
                control.value[key]["selected_dates"] = [];
                control.value[key]["type"] = addon.type;
              }
            } else if (
              control.value[key].id == addon.id &&
              control.value[key]["selected_dates"]
            ) {
              this.previousSelectedDates = control.value[key]["selected_dates"];

              this.formatDates.map((date) => {
                date.isChecked = false;
                if (control.value[key]["selected_dates"].includes(date.date)) {
                  date.isChecked = true;
                }
              });
              this.totalDays = control.value[key]["selected_dates"].length;
            }
          }
        }
      }
    }
  }

  // Change addon option
  changeOption(event, ind) {
    this.selectedOptionValue = event.target.value;
    for (let i = 0; i < this.selectedAddonDetail.options.length; i++) {
      this.selectedAddonDetail.options[i].isChecked = false;
      if (i == ind) {
        this.selectedAddonDetail.options[i].isChecked = true;
      }
    }

    const control = <FormArray>this.petDetails.controls["pets"];
    if (control.controls.length > 0) {
      for (const index in control.controls) {
        if (control.controls.hasOwnProperty(index)) {
          if (control.controls[index].value.id == this.selectedPetId) {
            if (event.target.checked) {
              for (const addon of control.controls[index].value["addons"]) {
                if (addon.id == this.selectedAddonDetail.id) {
                  addon["selected_option"] = event.target.value;
                }
              }
            }
            break;
          }
        }
      }
    }
  }
  checkaddonIsExists(addons, addonId) {
    if (addons && addons.length) {
      var isAddonIdPresent = addons.some(function (addon) {
        return addon.id === addonId;
      });

      if (isAddonIdPresent) {
        return true;
      } else {
        return false;
      }
    }
  }
  getDatesInRange() {
    const start = new Date(new Date(this.inwardDate));
    const end = new Date(new Date(this.outwardDate));
    const date = new Date(start.getTime());
    this.formatDates = [];
    while (date < end) {
      this.formatDates.push({
        date: moment(date).format("YYYY-MM-DD"),
        isChecked: true,
      });
      date.setDate(date.getDate() + 1);
    }
  }
  selectDate(event, date) {
    const control = <FormArray>this.petDetails.controls["pets"];
    if (control.controls.length > 0) {
      for (const index in control.controls) {
        if (control.controls.hasOwnProperty(index)) {
          if (control.controls[index].value.id == this.selectedPetId) {
            for (const addon of control.controls[index].value["addons"]) {
              if (addon.id == this.selectedAddonDetail.id) {
                this.previousSelectedDates = JSON.parse(
                  JSON.stringify(addon["selected_dates"])
                );
                if (
                  addon["selected_dates"] &&
                  !addon["selected_dates"].includes(date.date)
                ) {
                  addon["selected_dates"].push(date.date);
                  date.isChecked = true;
                } else {
                  addon["selected_dates"].splice(
                    addon["selected_dates"].indexOf(date.date),
                    1
                  );
                  date.isChecked = false;
                }
                this.totalDays = addon["selected_dates"].length;
              } else {
                let control = <FormControl>(
                  this.petDetails.controls["pets"]["controls"][
                    this.selectedPetIndex
                  ]["controls"]["addons"]
                );
                const isAddonIncluded = control.value.some(
                  (item) => item.id === this.selectedAddonDetail.id
                );
                if (!isAddonIncluded) {
                  if (!event.target.checked) {
                    this.formatDates.map((elem) => {
                      if (elem.date == date.date) {
                        elem.isChecked = false;
                      }
                    });
                    this.totalDays = this.formatDates.filter(
                      (date) => date.isChecked
                    ).length;
                  } else {
                    this.totalDays = 1;
                  }
                }
              }
            }

            if (!control.controls[index].value["addons"].length) {
              this.formatDates.map((elem) => {
                if (elem.date == date.date) {
                  if (!event.target.checked) {
                    elem.isChecked = false;
                  } else {
                    elem.isChecked = true;
                  }
                }
              });
              this.totalDays = this.formatDates.filter(
                (date) => date.isChecked
              ).length;
            }
          }
        }
      }
    }
  }
  onSubmit() {
    let control = <FormControl>(
      this.petDetails.controls["pets"]["controls"][this.selectedPetIndex][
        "controls"
      ]["addons"]
    );

    let addonObj = {
      id: this.selectedAddonDetail.id,
      selected_dates: [],
      selected_option: "",
      type: this.selectedAddonDetail.type,
    };

    let addons = JSON.parse(JSON.stringify(control.value));

    let hasCheckedTrue;

    if (this.selectedAddonDetail.options !== null) {
      hasCheckedTrue = this.selectedAddonDetail.options.some(
        (option) => option.isChecked
      );
    }
    const isAddonIncluded = addons.some(
      (item) => item.id === this.selectedAddonDetail.id
    );
    if (
      this.selectedAddonDetail.options &&
      this.selectedAddonDetail.options !== null &&
      !isAddonIncluded &&
      !hasCheckedTrue
    ) {
      addonObj["selected_option"] = this.selectedAddonDetail.options[0].value;
      addons.push(addonObj);
    }

    if (
      this.selectedAddonDetail.options &&
      this.selectedAddonDetail.options !== null &&
      !isAddonIncluded &&
      hasCheckedTrue
    ) {
      addonObj["selected_option"] = this.selectedOptionValue
        ? this.selectedOptionValue
        : this.selectedAddonDetail.options[0].value;
      addons.push(addonObj);
    }
    if (
      this.selectedAddonDetail.options == null &&
      this.selectedAddonDetail.type !== "all"
    ) {
      if (!isAddonIncluded) {
        addons.push(addonObj);
      }
    }
    control.setValue(addons);

    for (const key in control.value) {
      if (
        this.selectedAddonDetail &&
        this.selectedAddonDetail.options &&
        this.selectedAddonDetail.options.length
      ) {
        if (
          control.value[key].id == this.selectedAddonDetail.id &&
          control.value[key]["selected_option"] == ""
        ) {
          this.selectedAddonDetail.options.map((option) => {
            option.isChecked = false;
          });
          control.value[key]["selected_option"] =
            this.selectedAddonDetail.options[0].value;
          this.selectedAddonDetail.options[0].isChecked = true;
        } else if (
          control.value[key].id == this.selectedAddonDetail.id &&
          control.value[key]["selected_option"]
        ) {
          this.selectedAddonDetail.options.map((option) => {
            option.isChecked = false;
            if (option.value == control.value[key]["selected_option"]) {
              option.isChecked = true;
            }
          });
        }
      }

      // For Date selection
      if (this.formatDates && this.formatDates.length) {
        if (
          control.value[key].id == this.selectedAddonDetail.id &&
          !control.value[key]["selected_dates"].length
        ) {
          if (this.selectedAddonDetail.type == "custom") {
            this.formatDates.map((date) => {
              if (date.isChecked) {
                control.value[key]["selected_dates"].push(date.date);
                control.value[key]["type"] = this.selectedAddonDetail.type;
              }
            });
          }

          if (this.selectedAddonDetail.type == "single") {
            control.value[key]["selected_dates"] = [];
            control.value[key]["type"] = this.selectedAddonDetail.type;
          }

          if (this.selectedAddonDetail.type == "all") {
            this.formatDates.map((date) => {
              control.value[key]["selected_dates"].push(date.date);
              control.value[key]["type"] = this.selectedAddonDetail.type;
            });
          }
          this.totalDays = control.value[key]["selected_dates"].length;
        } else if (
          control.value[key].id == this.selectedAddonDetail.id &&
          control.value[key]["selected_dates"]
        ) {
          this.formatDates.map((date) => {
            date.isChecked = false;
            if (control.value[key]["selected_dates"].includes(date.date)) {
              date.isChecked = true;
            }
          });
          this.totalDays = control.value[key]["selected_dates"].length;
        }
      }
    }
    control.setValue(addons);

    if (this.selectedAddonDetail.type !== "single") {
      for (let i = 0; i < this.myAddons.length; i++) {
        if (this.myAddons[i].id == this.selectedAddonDetail.id) {
          this.myAddons[i].addonCheckoutPrice =
            this.selectedAddonDetail.price * this.totalDays;
        }
      }
    }
    this.modalService.dismissAll();
  }
  getClinicTiming() {
    this.http.post(API_URLS.clinicTiming, {}, false).subscribe((res: any) => {
      this.clinicTiming = res.data;

      //get days

      let inwardDate = new Date(this.inwardDate);
      let inwardDay = this.days[inwardDate.getDay()];

      let outwardDate = new Date(this.outwardDate);
      let outwardDay = this.days[outwardDate.getDay()];

      if (this.clinicTiming[inwardDay]) {
        // For inward Time

        this.inwardTime = this.clinicTiming[inwardDay].From;
        this.inwardHour = parseInt(this.inwardTime.split(":")[0], 10);
        this.inwardMinute = this.inwardTime.split(":")[1].split(" ")[0];

        const isInwardPM = this.inwardTime.includes("PM");

        if (isInwardPM && this.inwardHour !== 12) {
          this.inwardHour += 12;
        } else if (!isInwardPM && this.inwardHour === 12) {
          this.inwardHour = 0;
        }

        const inwardTime = new Date();
        inwardTime.setHours(this.inwardHour);
        inwardTime.setMinutes(0);

        this.inwardTime = inwardTime;

        // End

        // For outward time

        this.outwardTime = this.clinicTiming[outwardDay].To;
        this.outwardHour = parseInt(this.outwardTime.split(":")[0], 10);
        this.outwardMinute = this.outwardTime.split(":")[1].split(" ")[0];

        const isOutwardPM = this.outwardTime.includes("PM");

        if (isOutwardPM && this.outwardHour !== 12) {
          this.outwardHour += 12;
        } else if (!isOutwardPM && this.outwardHour === 12) {
          this.outwardHour = 0;
        }

        const outwardTime = new Date();
        outwardTime.setHours(this.outwardHour);
        outwardTime.setMinutes(0);

        this.outwardTime = outwardTime;

        // end
      }
      this.errorMessageInWardTime = "";
      this.errorMessageOutWardTime = "";
    });
  }

  // handle next step click
  goToNext(tabValue) {
    if (this.active == "tab12" || this.active == "tab13") {
      this.getBookingPrice();
    }

    // Get the index of the active tab
    const currentIndex = this.getCurrentIndex(this.active, ""); // Extract the number from the active tab ID

    // If there's a next tab, select it
    if (currentIndex < 14) {
      const nextTabId = `tab${currentIndex + 1}`;
      this.active = nextTabId;

      // Change the color of the previous tab
      const previousTabId = `tab${currentIndex}`;

      const previousTabElement = document.getElementById(previousTabId);
      if (previousTabElement) {
        previousTabElement.querySelector("button").classList.add("completed"); // Change to desired color
      }

      const buttonElement = previousTabElement.querySelector("button");
      if (buttonElement) {
        // Check if the completed class is present
        const isCompleted = buttonElement.classList.contains("completed");
        // Set flag or mark as right based on the completed status
        if (isCompleted) {
          // Set flag or mark as right here
          if (previousTabId == "tab8") {
            this.isRightMarkForFirst = true;
          } else if (previousTabId == "tab9") {
            this.isRightMarkForSecond = true;
          } else if (previousTabId == "tab10") {
            this.isRightMarkForThird = true;
          } else if (previousTabId == "tab11") {
            this.isRightMarkForForth = true;
          } else if (previousTabId == "tab12") {
            this.isRightMarkForFifth = true;
          } else if (previousTabId == "tab13") {
            this.isRightMarkForSixth = true;
          }
        }
      }
    }
    if (this.activeTabs.includes(tabValue)) {
      this.activeTabs.splice(this.activeTabs.indexOf(tabValue), 1);
    }
  }

  goToPrev() {
    // Get the index of the active tab
    const currentIndex = this.getCurrentIndex(this.active, ""); // Extract the number from the active tab ID

    // If there's a previous tab, select it
    if (currentIndex > 1) {
      const previousTabId = `tab${currentIndex - 1}`;
      this.active = previousTabId;

      // Remove the completed class from the current tab button
      const currentTabId = `tab${currentIndex}`;

      const currentTabElement = document.getElementById(currentTabId);
      const prevTabElement = document.getElementById(previousTabId);

      const buttonElement = prevTabElement.querySelector("button");
      if (buttonElement) {
        // Check if the completed class is present
        const isCompleted = buttonElement.classList.contains("completed");
        // Set flag or mark as right based on the completed status
        if (isCompleted) {
          // Set flag or mark as right here
          if (previousTabId == "tab8") {
            this.isRightMarkForFirst = false;
          } else if (previousTabId == "tab9") {
            this.isRightMarkForSecond = false;
          } else if (previousTabId == "tab10") {
            this.isRightMarkForThird = false;
          } else if (previousTabId == "tab11") {
            this.isRightMarkForForth = false;
          } else if (previousTabId == "tab12") {
            this.isRightMarkForFifth = false;
          } else if (previousTabId == "tab13") {
            this.isRightMarkForSixth = false;
          }
        }
      }

      if (currentTabElement) {
        currentTabElement.querySelector("button").classList.remove("completed");
      }
    }
  }
  changeTab(event) {
    // Get the index of the newly selected tab
    const activeTabIndex = this.getCurrentIndex("", event);
    // Update the completed status of tabs
    this.updateTabCompletionStatus(activeTabIndex);
  }
  // Define a method to update the completed status of tabs
  updateTabCompletionStatus(activeTabIndex: number) {
    for (let i = 8; i <= 14; i++) {
      const tabId = `tab${i}`;
      const tabElement = document.getElementById(tabId);
      if (tabElement) {
        const buttonElement = tabElement.querySelector("button");
        if (buttonElement) {
          if (i < activeTabIndex) {
            buttonElement.classList.add("completed");
          } else {
            buttonElement.classList.remove("completed");
          }
        }
      }

      if (activeTabIndex == 8) {
        this.isRightMarkForFirst = false;
        this.isRightMarkForSecond = false;
        this.isRightMarkForThird = false;
        this.isRightMarkForForth = false;
        this.isRightMarkForFifth = false;
        this.isRightMarkForSixth = false;
      } else if (activeTabIndex == 9) {
        this.isRightMarkForFirst = true;
        this.isRightMarkForSecond = false;
        this.isRightMarkForThird = false;
        this.isRightMarkForForth = false;
        this.isRightMarkForFifth = false;
        this.isRightMarkForSixth = false;
      } else if (activeTabIndex == 10) {
        this.isRightMarkForFirst = true;
        this.isRightMarkForSecond = true;
        this.isRightMarkForThird = false;
        this.isRightMarkForForth = false;
        this.isRightMarkForFifth = false;
        this.isRightMarkForSixth = false;
      } else if (activeTabIndex == 11) {
        this.isRightMarkForFirst = true;
        this.isRightMarkForSecond = true;
        this.isRightMarkForThird = true;
        this.isRightMarkForForth = false;
        this.isRightMarkForFifth = false;
        this.isRightMarkForSixth = false;
      } else if (activeTabIndex == 12) {
        this.isRightMarkForFirst = true;
        this.isRightMarkForSecond = true;
        this.isRightMarkForThird = true;
        this.isRightMarkForForth = true;
        this.isRightMarkForFifth = false;
        this.isRightMarkForSixth = false;
      } else if (activeTabIndex == 13) {
        this.isRightMarkForFirst = true;
        this.isRightMarkForSecond = true;
        this.isRightMarkForThird = true;
        this.isRightMarkForForth = true;
        this.isRightMarkForFifth = true;
        this.isRightMarkForSixth = false;
      } else if (activeTabIndex == 14) {
        this.isRightMarkForFirst = true;
        this.isRightMarkForSecond = true;
        this.isRightMarkForThird = true;
        this.isRightMarkForForth = true;
        this.isRightMarkForFifth = true;
        this.isRightMarkForSixth = true;
      }
    }
  }

  getCurrentIndex(activeTab?, event?) {
    if (event) {
      return parseInt(event.nextId.substr(3));
    } else if (activeTab) {
      return parseInt(this.active.substring(3));
    }
  }
  resetNavTab() {
    this.active = "tab8";
    this.updateTabCompletionStatus(8);
    this.activeTabs = [
      "plan",
      "time",
      "pet_details",
      "addons",
      "mandatory_products",
      "payment",
    ];
  }
  addClassOnDatePicker() {
    const calendarElement = document.querySelector(".p-datepicker");
    if (calendarElement) {
      this.renderer.removeClass(calendarElement, "modal-p-datepicker");
      this.renderer.addClass(calendarElement, "modal-p-datepicker");
    }
  }
}
